import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-for-switch"]
const _hoisted_2 = { class: "Tool__content" }




export default /*@__PURE__*/_defineComponent({
  __name: 'Tool',
  props: {
    label: {
        type: String,
        required: true,
    },
    forSwitch: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Tool",
    "data-for-switch": __props.forSwitch
  }, [
    _createElementVNode("label", null, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})